import { Button, Form, Input } from 'antd';
import React from 'react';
import { useCountries } from './CountryStore';

function Add(props) {
    let { createCountry } = useCountries()
    return (
        <Form layout="vertical" onFinish={createCountry} encType="multipart/form-data">
            <Form.Item label="O'zbekcha nomi" name="nameuz" rules={[{ required: true, message: 'Please input your name!' }]}>
                <Input />
            </Form.Item>
            <Form.Item label="Ruscha nomi" name="nameru" rules={[{ required: true, message: 'Please input your description!' }]}>
                <Input />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">Qo'shish</Button>
            </Form.Item>
        </Form>
    );
}

export default Add;